let envUrl,
	webUrl,
	merchUrl,
	env = process.env.VUE_APP_API_ENV;

if (env == 'production') {envUrl = "https://efundraisingapi1.azurewebsites.net/api";
							webUrl =  "https://www.efundraisingconnections.com";
							merchUrl = "https://merch.efundraisingconnections.com";}

if (env == 'staging') {envUrl = "https://efundraisingapi1-staging.azurewebsites.net/api";
						webUrl =  "https://staging.efundraisingconnections.com";
						merchUrl = "https://merchstaging.efundraisingconnections.com";}

if (env == 'example') {envUrl = "https://efundraisingapi1-example.azurewebsites.net/api";
						webUrl =  "http://example.efundraisingconnections.com";
						merchUrl = "https://merchexample.efundraisingconnections.com";}

if (env == 'testapi') {envUrl = "https://efundraisingapi1-test.azurewebsites.net/api";
						webUrl =  "https://test.efundraisingconnections.com";
						merchUrl = "https://merchtest.efundraisingconnections.com";}

if (env == 'dev') {envUrl = "https://efundraisingapi1-test.azurewebsites.net/api";
						webUrl =  "https://test.efundraisingconnections.com";
						merchUrl = "https://merchtest.efundraisingconnections.com";}

if (env == 'localtunnel') envUrl = "http://cts-efund.loca.lt/api";
if (env == 'local') {envUrl = "http://localhost:61591/api";
						merchUrl = "https://localhost:7017";}

if(webUrl == undefined) {webUrl =  "https://test.efundraisingconnections.com";}
if(merchUrl == undefined) {merchUrl = "https://merchtest.efundraisingconnections.com";}


export default {
	apiUrl: envUrl,
	websiteUrl: webUrl,
	merchUrl: merchUrl,
};